/**
 * Logs API client — HTTP fallback only for v1.
 *
 * Live streaming over the multiplexed WebSocket (`logs:<agent>`) lands
 * in a follow-up PR. For now the LogViewer polls this endpoint every
 * ~2s and diffs against its last tail.
 */
import { api } from '@/api/client';

export interface LogTailResponse {
  agent: string;
  lines: string[];
  next_offset?: number;
}

export const logsApi = {
  async tail(agent: string, params?: { tail?: number; since?: number }): Promise<LogTailResponse> {
    const search = new URLSearchParams();
    if (params?.tail !== undefined) search.set('tail', String(params.tail));
    if (params?.since !== undefined) search.set('since', String(params.since));
    const qs = search.toString();
    return api<LogTailResponse>(
      `/agents/${encodeURIComponent(agent)}/logs${qs ? `?${qs}` : ''}`
    );
  },

  downloadUrl(agent: string): string {
    return `/api/agents/${encodeURIComponent(agent)}/logs/download`;
  },
};
